export const addBreak = (text: string, loc: number) => {
  const num = loc || 2; // Default to 2 if no loc is provided

  const words = text.split(" ");
  if (words.length > num) {
    return (
      <>
        {words.slice(0, -num).join(" ")} <br />
        {words.slice(-num).join(" ")}
      </>
    );
  }
  return text;
};
